export const HashtagPoint = {
  pageName: 'Hashtag',
  pageId: '25101',
  pagePath: '/marketing/Hashtag',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    SortButton: {
      buttonId: '2510101',
    },
    ClickHashtag: {
      buttonId: '2510103',
    },
  },
  card: {},
  table: {
    HashtagTable: {
      Sort: {
        buttonId: '2510102',
      },
      Paging: {
        buttonId: '2510104',
      },
    },
  },
};

export const HashtagDetailPoint = {
  pageName: 'Hashtag Detail',
  pageId: '25102',
  pagePath: '/marketing/Hashtag/Details',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {},
  card: {},
};
